/**
 * AuraFrame TV Backlight — Variant Sync JS
 * Connects custom variant UI → Shopify product form → sticky cart
 * Minimal, no dependencies, fully scoped to auraframe- elements
 */

(function () {
  'use strict';

  // ── Money formatting ───────────────────────────────────────────
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── Get all variant data from embedded JSON ────────────────────
  function getVariants() {
    var el = document.getElementById('auraframe-variants-json');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  // ── Update all price displays on page ─────────────────────────
  function updatePriceDisplays(variant) {
    if (!variant) return;

    var currentPrice  = formatMoney(variant.price);
    var comparePrice  = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;

    // Hero price display
    var heroPrice   = document.querySelector('.auraframe-price-display__current');
    var heroCompare = document.querySelector('.auraframe-price-display__compare');
    var heroSave    = document.querySelector('.auraframe-price-display__save');

    if (heroPrice)   heroPrice.textContent = currentPrice;
    if (heroCompare) {
      if (comparePrice) {
        heroCompare.textContent = comparePrice;
        heroCompare.style.display = '';
      } else {
        heroCompare.style.display = 'none';
      }
    }
    if (heroSave && variant.compare_at_price && variant.compare_at_price > variant.price) {
      var saved = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      heroSave.textContent = 'Save ' + saved + '%';
      heroSave.style.display = '';
    } else if (heroSave) {
      heroSave.style.display = 'none';
    }

    // Sticky cart price
    var stickyPrice   = document.querySelector('.auraframe-sticky__price-amount');
    var stickyCompare = document.querySelector('.auraframe-sticky__compare');
    if (stickyPrice)   stickyPrice.textContent = currentPrice;
    if (stickyCompare) {
      if (comparePrice) {
        stickyCompare.textContent = comparePrice;
        stickyCompare.style.display = '';
      } else {
        stickyCompare.style.display = 'none';
      }
    }
  }

  // ── Update all hidden variant ID inputs ───────────────────────
  function updateVariantInputs(variantId) {
    document.querySelectorAll('.auraframe-variant-id-input').forEach(function (input) {
      input.value = variantId;
    });
  }

  // ── Update ATC button states ───────────────────────────────────
  function updateAtcButtons(variant) {
    var available = variant && variant.available;
    var label = available ? 'Add to Cart' : 'Sold Out';

    document.querySelectorAll('.auraframe-atc-btn').forEach(function (btn) {
      btn.disabled = !available;
      btn.textContent = label;
    });
    document.querySelectorAll('.auraframe-sticky__btn').forEach(function (btn) {
      btn.disabled = !available;
      btn.textContent = label;
    });
  }

  // ── Update active state on custom variant UI options ──────────
  function updateVariantOptionUI(variantId) {
    document.querySelectorAll('.auraframe-variant-option[data-variant-id]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.variantId === String(variantId));
    });
    document.querySelectorAll('.auraframe-size-card[data-variant-id]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.variantId === String(variantId));
    });
  }

  // ── Select a variant by ID ────────────────────────────────────
  function selectVariant(variantId) {
    var variants = getVariants();
    var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    updateVariantInputs(variantId);
    updateVariantOptionUI(variantId);
    updatePriceDisplays(variant);
    updateAtcButtons(variant);

    // Sync native Shopify select (if theme uses one internally for cart logic)
    var nativeSelect = document.querySelector('select[name="id"].auraframe-native-select');
    if (nativeSelect) {
      nativeSelect.value = variantId;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ── Bind custom variant option click handlers ─────────────────
  function bindVariantOptions() {
    document.querySelectorAll('.auraframe-variant-option[data-variant-id], .auraframe-size-card[data-variant-id]')
      .forEach(function (el) {
        el.addEventListener('click', function () {
          selectVariant(el.dataset.variantId);
        });
      });
  }

  // ── FAQ accordion ─────────────────────────────────────────────
  function bindFaq() {
    document.querySelectorAll('.auraframe-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.auraframe-faq__item');
        var wasOpen = item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.auraframe-faq__item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
        });
        // Toggle clicked
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  // ── Sticky cart ATC submit ─────────────────────────────────────
  function bindStickyCart() {
    var stickyForm = document.getElementById('auraframe-sticky-form');
    if (!stickyForm) return;
    stickyForm.addEventListener('submit', function (e) {
      // Let native Shopify form handle it — no preventDefault
      // Optionally show loading state
      var btn = stickyForm.querySelector('.auraframe-sticky__btn');
      if (btn) {
        btn.textContent = 'Adding…';
        setTimeout(function () {
          btn.textContent = 'Add to Cart';
        }, 2000);
      }
    });
  }

  // ── Hide sticky when main ATC is visible ──────────────────────
  function bindStickyVisibility() {
    var sticky = document.querySelector('.auraframe-sticky');
    var heroForm = document.getElementById('auraframe-hero-form');
    if (!sticky || !heroForm) return;

    function check() {
      var rect = heroForm.getBoundingClientRect();
      var heroVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      sticky.style.opacity = heroVisible ? '0' : '1';
      sticky.style.pointerEvents = heroVisible ? 'none' : '';
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // ── Init ──────────────────────────────────────────────────────
  function init() {
    bindVariantOptions();
    bindFaq();
    bindStickyCart();
    bindStickyVisibility();

    // Select default variant on load
    var defaultInput = document.querySelector('.auraframe-variant-id-input');
    if (defaultInput && defaultInput.value) {
      var variantId = defaultInput.value;
      updateVariantOptionUI(variantId);
      var variants = getVariants();
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      if (variant) {
        updatePriceDisplays(variant);
        updateAtcButtons(variant);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
